module.exports = __webpack_public_path__ + "frog-a2792c6636ea8a83579cf7c19f012682.png";